import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";

const useTelephoneConfig = () => {
  const { lead } = useLeadInfo();

  const hasTelephones =
    lead?.data?.lead?.lead_telephones &&
    lead?.data?.lead?.lead_telephones?.length > 0;

  const primaryTelephone = lead?.data?.lead?.lead_telephones?.find(
    (telephone) => telephone.primary === true
  );
  const remainingNumbersCount =
    hasTelephones && lead?.data?.lead?.lead_telephones?.length > 1
      ? lead?.data?.lead?.lead_telephones?.length - 1
      : 0;
  const hasMoreThanOneTelephone =
    hasTelephones && lead?.data?.lead?.lead_telephones?.length > 1;

  const otherNumbers = lead?.data?.lead?.lead_telephones?.filter(
    (telephone) => telephone.primary === false
  );

  return {
    primaryTelephone,
    remainingNumbersCount,
    hasMoreThanOneTelephone,
    otherNumbers,
  };
};

export default useTelephoneConfig;
